var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.978,
    height: 26,
    viewBox: "0 0 24.978 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete_Icon",
    transform: "translate(-2901 -587.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    d: "M2.271,2.271v15.9h15.9V2.271H2.271M0,0H20.437V18.166a2.271,2.271,0,0,1-2.271,2.271H2.271A2.271,2.271,0,0,1,0,18.166Z",
    transform: "translate(2903.271 593.113)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 24.978,
    height: 2.271,
    transform: "translate(2901 593.113)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 11.354,
    height: 2.271,
    transform: "translate(2907.812 609.009) rotate(-90)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 11.354,
    height: 2.271,
    transform: "translate(2912.354 609.009) rotate(-90)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 11.354,
    height: 2.271,
    transform: "translate(2916.895 609.009) rotate(-90)",
    fill: "#91b6bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M2905.8,593.113h-2.271s0-2.237,0-3.155a1.223,1.223,0,0,0-.239-.137h-6.458a1.579,1.579,0,0,0-.929.186v3.107h-2.271v-3.25c.007-.807.685-2.313,3.2-2.313h6.81l.15.042a2.562,2.562,0,0,1,2.007,2.271C2905.8,590.711,2905.8,593.113,2905.8,593.113Z",
    transform: "translate(13.342 0)",
    fill: "#91b6bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/Delete_Icon.01bb3e19.svg";
export { ForwardRef as ReactComponent };